module.exports = __webpack_public_path__ + "img/logo34.9e4726b9.png";